// Environment adapter: the connection state machine does not read browser globals.
export default class BrowserLifecycle {
  #window;
  #document;
  #pauseWhenHidden;
  constructor(windowObject, documentObject, pauseWhenHidden) {
    this.#window = windowObject;
    this.#document = documentObject;
    this.#pauseWhenHidden = pauseWhenHidden;
  }

  state() {
    if (this.#window.prokatProstAppPaused || (this.#pauseWhenHidden && this.#document.visibilityState === 'hidden')) return 'paused';
    if (this.#window.navigator.onLine === false) return 'offline';
    return 'available';
  }

  subscribe(onChange) {
    const visibility = () => onChange(this.state());
    const offline = () => onChange('offline');
    const online = () => onChange(this.state());
    this.#document.addEventListener('visibilitychange', visibility);
    this.#window.addEventListener('online', online);
    this.#window.addEventListener('offline', offline);
    return () => {
      this.#document.removeEventListener('visibilitychange', visibility);
      this.#window.removeEventListener('online', online);
      this.#window.removeEventListener('offline', offline);
    };
  }
}
